'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactMeasure = require('react-measure');var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
var _reactInfiniteScroller = require('react-infinite-scroller');var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);

var _Footer = require('../Footer/Footer');var _Footer2 = _interopRequireDefault(_Footer);
var _components = require('../../components');







var _OMPropertyListCell = require('../OMComponents/OMPropertyCells/OMPropertyListCell');var _OMPropertyListCell2 = _interopRequireDefault(_OMPropertyListCell);

var _formatCityName = require('../../helpers/formatCityName');var _formatCityName2 = _interopRequireDefault(_formatCityName);
var _constants = require('../../constants');







var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);
var _fetchPropertyNoteById = require('../../utils/fetchPropertyNoteById');var _fetchPropertyNoteById2 = _interopRequireDefault(_fetchPropertyNoteById);
var _formatSEOData = require('../../utils/formatSEOData');
var _checkIsNewProperty = require('../../utils/checkIsNewProperty');
var _getOpenedModalPropsInRoute = require('../../utils/getOpenedModalPropsInRoute');var _getOpenedModalPropsInRoute2 = _interopRequireDefault(_getOpenedModalPropsInRoute);
var _getLocalizedData = require('../../utils/getLocalizedData');var _getLocalizedData2 = _interopRequireDefault(_getLocalizedData);
var _google = require('../../utils/analytics/google');
var _isDeepEmpty = require('../../utils/is-deep-empty');var _isDeepEmpty2 = _interopRequireDefault(_isDeepEmpty);
var _buildVideoLinks = require('../../utils/buildVideoLinks');var _buildVideoLinks2 = _interopRequireDefault(_buildVideoLinks);
var _PropertyNearbyCell = require('../PropertyNearbyCell/PropertyNearbyCell');var _PropertyNearbyCell2 = _interopRequireDefault(_PropertyNearbyCell);

var _PropertiesList = require('./PropertiesList.scss');var styles = _interopRequireWildcard(_PropertiesList);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var PropertiesList = function (_Component) {_inherits(PropertiesList, _Component);
  function PropertiesList(props) {_classCallCheck(this, PropertiesList);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    _this.state = {
      propertyHeight: 0,
      componentHeight: 0 };

    _this.todayDate = new Date();return _this;
  }PropertiesList.prototype.

  componentDidMount = function componentDidMount() {
    if (this.props.isMobile) {
      this.sessionStart = Date.now();
    }

    this.propertiesList = document.querySelector('#propertiesList');
  };PropertiesList.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(newProps) {var
    routeData = newProps.routeData,isMobileFiltersOpen = newProps.isMobileFiltersOpen;

    var isFavoritePage = !this.props.routeData.favorites && !!routeData.favorites;

    if (
    !this.props.isMobile && routeData.route !== this.props.routeData.route &&
    !(0, _getOpenedModalPropsInRoute2.default)(routeData.route).length &&
    !(0, _getOpenedModalPropsInRoute2.default)(this.props.routeData.route).length && !routeData.favorites || isFavoritePage)
    {
      this.scrollUp();
    }

    if (this.props.isMobileFiltersOpen && !isMobileFiltersOpen) {
      this.propertiesList.scrollTop = 0;
    }
  };PropertiesList.prototype.

  componentWillUnmount = function componentWillUnmount() {
    if (this.props.isMobile) {
      this.sessionEnd = Date.now();
      var time = this.sessionEnd - this.sessionStart;
      (0, _google.gaSetTimedEvent)({ page: 'Properties Search', time: time, label: 'List - Mobile' });
    }
  };PropertiesList.prototype.
































































































































































































































































  renderProjectsNoResults = function renderProjectsNoResults() {var
    isMobile = this.props.isMobile;
    var searchString = isMobile ? 'change_search_settings_mobile1' : 'change_search_settings';

    return (
      _react2.default.createElement('div', { className: styles.noResultBlock },
        _react2.default.createElement('div', { className: styles.noResults }, this.props.translate('search_box', 'no_results')),

        _react2.default.createElement('div', null, this.props.translate('search_box', searchString)),

        this.props.isMobile &&
        _react2.default.createElement('div', null,
          _react2.default.createElement('span', null, this.props.translate('search_box', 'change_search_settings_mobile2')))));




  };PropertiesList.prototype.

  renderPropertiesNoResults = function renderPropertiesNoResults() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.saveSearchBlock, styles.noResults) },
        _react2.default.createElement(_components.PropertiesListSaveSearchBlock, {
          rootTranslate: this.props.translate,
          saveSearchLocation: this.props.saveSearchLocation })));



  };PropertiesList.prototype.



  renderFavoritesNoResults = function renderFavoritesNoResults() {
    return this.props.favoriteProperties.length ?
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.noResultBlock, styles.displayAllFavorites) },
      _react2.default.createElement('div', { className: styles.noResults }, this.props.translate('favoritesNoResults', 'noPropertiesOnMap')),
      _react2.default.createElement('div', { className: styles.displayAll },
        this.props.translate('favoritesNoResults', 'displayAll'),
        _react2.default.createElement('span', { onClick: this.props.displayAllFavorites }, '\xA0', this.props.translate('favoritesNoResults', 'clickHere')))) :



    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.noResultBlock, styles.noFavorites) },
      _react2.default.createElement('div', { className: styles.noResults }, this.props.translate('favoritesNoResults', 'noResults')),
      _react2.default.createElement('div', null,
        this.props.translate('favoritesNoResults', 'clickOnButton'),
        _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.favoriteIcon, 'icon icon-favorite') }),
        this.props.translate('favoritesNoResults', 'onTheProperty')),

      _react2.default.createElement('div', null, this.props.translate('favoritesNoResults', 'addToFavorites')));


  };PropertiesList.prototype.

  render = function render() {var _cx,_this2 = this,_cx2;var _props =
    this.props,properties = _props.properties,loading = _props.loading,loaded = _props.loaded,isFavoritesList = _props.isFavoritesList,companyFindByNeighborhood = _props.companyFindByNeighborhood;
    var haveProperties = properties.length > 0;
    var location = (0, _get2.default)(this.props, 'routeData.location');
    var isProjects = location === 'projects';

    var propertiesCount = (this.props.properties || []).length;

    var propertiesList = null;
    if (haveProperties) {
      propertiesList = properties.map(isProjects ? this.renderProjectsCell : this.renderEntityByType);
      // propertiesList = propertiesList.reduce(this.addBanners, []); // TODO Uncomment for banners
      // important to check if equals false and not !this.props.loading
    } else if (loading === false && loaded) {
      propertiesList = isFavoritesList ? this.renderFavoritesNoResults() : this.renderNoResults(isProjects);
    } else if (loading) {
      propertiesList = _react2.default.createElement('div', { className: styles.spinnerPosition }, _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }));
    } else {
      // TODO: Display localised error message - most likely can't connect to the server
    }

    return (
      _react2.default.createElement('div', {
          id: 'propertiesList',
          className: (0, _classnames2.default)(styles.propertiesListWrapper, (_cx = {}, _cx[
          styles.propertiesList] = haveProperties, _cx[
          styles.noPropertiesList] = !haveProperties, _cx[
          styles.projectsList] = isProjects, _cx)) },


        !isFavoritesList &&
        _react2.default.createElement(_components.PropertyListTopBlock, {
          isMobile: this.props.isMobile,
          loading: this.props.loading,
          translate: this.props.translate,
          propertiesQuantity: this.props.propertiesQuantity,
          projectsQuantity: this.props.projectsQuantity,
          transformDataForTitle: this.transformDataForTitle,
          searchProperty: this.props.searchProperty,
          routeData: this.props.routeData,
          saveSearchLocation: this.props.saveSearchLocation,
          skip: this.props.skip }),


        _react2.default.createElement(_reactInfiniteScroller2.default, {
            pageStart: 0,
            loadMore: this.loadMore,
            hasMore: !this.props.isLastPage,
            threshold: this.props.isMobile ? 125 : 250,
            useWindow: this.props.isMobile,
            getScrollParent: !this.props.isMobile ? function () {return _this2.props.containerRef;} : undefined,
            className:
            (0, _classnames2.default)(styles.propertiesListContent, (_cx2 = {}, _cx2[

            styles.opacityLayer] = loading, _cx2[
            styles.largeSideBar] = this.props.isLargeSideBar, _cx2)) },



          propertiesList || _react2.default.createElement('div', null)),


        _react2.default.createElement('div', { className: styles.bottomWrapper },
          !isFavoritesList &&
          _react2.default.createElement(_components.PropertyListBottomBlock, {
            isMobile: this.props.isMobile,
            hasNoFilters: this.selectHasNoFilters(this.props),
            updateRoute: this.props.updateRoute,
            routeLocation: (0, _get2.default)(this.props, 'routeData.location'),
            propertyType: (0, _get2.default)(this.props, 'routeData.params.types.0'),
            isSinglePropertyType: !!(0, _get2.default)(this.props, 'routeData.params.types.length', 0),
            optionType: (0, _get2.default)(this.props, 'routeData.optionType'),
            locationSearch: (0, _get2.default)(this.props, 'routeData.locationSearch'),
            loadedPropertiesCount: propertiesCount,
            loading: this.props.loading,
            translate: this.props.translate,
            translateCities: this.props.translateCities,
            translateProjects: this.props.translateProjects,
            locale: this.props.locale,
            loadMore: this.props.loadMore,
            isLastPage: this.props.isLastPage,
            componentHeight: this.state.componentHeight,
            propertyHeight: this.state.propertyHeight,
            transformDataForTitle: this.transformDataForTitle,
            propertiesQuantity: this.props.propertiesQuantity,
            projectsQuantity: this.props.projectsQuantity,
            scrollUp: this.scrollUp,
            saveSearchLocation: this.props.saveSearchLocation }),



          _react2.default.createElement(_Footer2.default, {
            className: 'listFooter',
            displaySocial: true,
            isMobile: this.props.isMobile,
            translate: this.props.translate,
            locale: this.props.locale,
            publishClicked: this.props.publishClicked,
            isRtl: this.props.isRtl,
            routeData: this.props.routeData,
            isFooterShown: true,
            inPropertiesList: true }))));




  };return PropertiesList;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this3 = this;this.scrollUp = function () {return _reactScroll.animateScroll.scrollToTop(!_this3.props.isMobile ? { containerId: 'side-bar', ignoreCancelEvents: true } : {});};this.handleMeasure = function (dimensions) {if (_this3.state.propertyHeight !== dimensions.height) {_this3.setState({ propertyHeight: dimensions.height });}};this.transformDataForTitle = function () {var _props2 = _this3.props,routeData = _props2.routeData,translate = _props2.translate;var routeParams = Object.assign({}, routeData, { params: Object.assign({}, routeData.params, { rooms: [] }) });return (0, _formatSEOData.formatSearchTitle)(routeParams, translate, { projects: (0, _upperFirst2.default)(translate('SEOsearch', 'projects')) });};this.handleHover = function (id) {return _this3.props.highlightPin && _this3.props.highlightPin({ id: id });};this.selectHasNoFilters = function (props) {var _props$routeData$para = props.routeData.params,params = _props$routeData$para === undefined ? {} : _props$routeData$para;var cleanedParams = Object.assign({}, params, { toilets: (params.toilets || []).filter(function (it) {return it !== 'all';}), bathrooms: (params.bathrooms || []).filter(function (it) {return it !== 'all';}) });var noParams = !!(!props.routeData.drawnPoly && (0, _isDeepEmpty2.default)(cleanedParams));return noParams;};this.loadMore = function () {if (!_this3.props.loaded || _this3.props.loading) {return;}var type = (0, _get2.default)(_this3.props, 'routeData.location');_this3.props.loadMore({ type: type, is_mobile: _this3.props.isMobile });};this.addBanners = function (acc, item, idx) {acc.push(item);var propertiesInRow = _this3.props.isMobile ? 1 : 3;var firstBannerSkipRows = _this3.props.isMobile ? 3 : 2;var bannerSkipRows = 5;var firstBannerSkipProperties = propertiesInRow * firstBannerSkipRows;var bannerSkipProperties = propertiesInRow * bannerSkipRows;var bannerTypesCount = 3;var idxOffset = _this3.props.isMobile ? 0 : 1;var bannerOrderNumber = bannerTypesCount - (idx + idxOffset) / propertiesInRow % bannerTypesCount;var shouldAddBanner = idx + 1 === firstBannerSkipProperties || !((idx + 1 - firstBannerSkipProperties) % bannerSkipProperties);if (shouldAddBanner) {// eslint-disable-next-line react/no-array-index-key
      acc.push(_react2.default.createElement(_components.ListBanner, { key: 'banner_' + idx, orderNumber: bannerOrderNumber, link: (0, _appendLocale2.default)(_this3.props.locale, '/company/' + (_constants.isProd ? 'HJ78sgpIH' : 'r1qtHMerH')) }));}return acc;};this.renderEntityByType = function (entity, idx) {return entity.entityType === _constants.ENTITY_TYPES.PROJECT || entity.banners ? _this3.renderProjectsCell(entity, idx) : _this3.renderPropertiesCell(entity, idx);};this.renderProjectsCell = function (project) {var _props3 = _this3.props,locale = _props3.locale,isMobile = _props3.isMobile,openDetailsPopup = _props3.openDetailsPopup,isRtl = _props3.isRtl;if (!!project && !!project.companyFindByNeighborhood) {return _react2.default.createElement(_components.CompanyInPropertiesList, { key: project.companyFindByNeighborhood.id, isMobile: _this3.props.isMobile, locale: _this3.props.locale, translate: _this3.props.translate, company: project.companyFindByNeighborhood, routeData: _this3.props.routeData, isRtl: _this3.props.isRtl });}var projectNote = (0, _fetchPropertyNoteById2.default)(project.id, _this3.props.propertyNotes);var name = (0, _getLocalizedData2.default)(project.name, locale);var summary = (0, _getLocalizedData2.default)(project.summary, locale);var address = (0, _getLocalizedData2.default)(project.address, locale, true);var _project$address$loca = project.address.location,lat = _project$address$loca.lat,lng = _project$address$loca.lon;var image = (0, _get2.default)(project, 'images[0]') || null;var logo = (0, _get2.default)(project, 'logo', null);var statusLocaliseData = _constants.projectStatuses.find(function (item) {return item.name === project.status;}) || {};var status = (0, _getLocalizedData2.default)(statusLocaliseData.localisation, locale);var isFavorite = _this3.props.favoriteProperties.indexOf(project.id) !== -1;var onHover = function onHover() {return _this3.handleHover(project.id);};if (project.banners) {return _react2.default.createElement(_reactMeasure2.default, { onMeasure: _this3.handleMeasure }, _react2.default.createElement(_PropertyNearbyCell2.default, { isFavorite: isFavorite, toggleFavorite: _this3.props.toggleFavorite, className: styles.nearbyProperty, property: project, isRtl: _this3.props.isRtl, translate: _this3.props.translate, locale: _this3.props.locale, isMobile: _this3.props.isMobile }));}return _react2.default.createElement(_reactMeasure2.default, { key: project.id, onMeasure: _this3.handleMeasure }, _react2.default.createElement('div', { onMouseLeave: _this3.props.disableHighlightPin }, _react2.default.createElement(_components.ProjectCellWrapper, { locale: locale, isMobile: isMobile, isFavorite: isFavorite, toggleFavorite: _this3.props.toggleFavorite, isRtl: isRtl, id: project.id, openDetailsPopup: openDetailsPopup, rooms: project.rooms || '', addProjectNote: _this3.props.addPropertyNote, projectNote: projectNote, childProps: { images: project.images, image: image && typeof image === 'string' ? (0, _modifyImageLink2.default)(image, _constants.imageModifierTypes.PROJECT_THUMBNAIL) : null, price: project.min_property_price, exactPrice: project.exact_property_price, name: name.result, logo: logo, locale: locale, isMobile: isMobile, summary: summary.result, address: address.result || {}, status: status.result, translate: _this3.props.translate, location: _this3.props.routeData.location, onHover: onHover } })));};this.renderPropertiesCell = function (property, idx) {if (!!property && !!property.companyFindByNeighborhood) {return _react2.default.createElement(_components.CompanyInPropertiesList, { key: property.companyFindByNeighborhood.id, isMobile: _this3.props.isMobile, locale: _this3.props.locale, translate: _this3.props.translate, company: property.companyFindByNeighborhood, routeData: _this3.props.routeData, isRtl: _this3.props.isRtl });}var englishAddressRequired = _constants.localesWithEnglishAddress.includes(_this3.props.locale);var address = englishAddressRequired ? property.address.en : property.address[_this3.props.locale] || property.address[_constants.language.default];var id = property.id,thumbnail = property.thumbnail,price = property.price,videos = property.videos,_property$additional_ = property.additional_info;_property$additional_ = _property$additional_ === undefined ? {} : _property$additional_;var rooms = _property$additional_.rooms,bathrooms = _property$additional_.bathrooms,parking = _property$additional_.parking,areaObject = _property$additional_.area;var isLand = property.property_type === 'land'; // temp patch
    var floor = isLand ? undefined : (0, _get2.default)(property, 'additional_info.floor.on_the');var roomsData = isLand ? undefined : rooms;var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';var addressString = address.street_name + ' ' + houseNumber;var _property$address$loc = property.address.location,lat = _property$address$loc.lat,lng = _property$address$loc.lon;var propertyImage = thumbnail || null;var propertyVideoPoster = videos && videos[0] && videos[0].id && (0, _buildVideoLinks2.default)(videos[0]).thumbnail;var area = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject; // for migration purposes
    var isFavorite = _this3.props.favoriteProperties.indexOf(id) !== -1;var propertyNote = (0, _fetchPropertyNoteById2.default)(id, _this3.props.propertyNotes);var optionType = (0, _get2.default)(_this3.props, 'routeData.optionType');var showPromotion = idx < 4;var isNewProperty = property.created_at ? (0, _checkIsNewProperty.checkIsNewProperty)(property.created_at, _this3.todayDate) : false;return _react2.default.createElement(_reactMeasure2.default, { key: id, onMeasure: _this3.handleMeasure }, _react2.default.createElement('div', { onMouseLeave: _this3.props.disableHighlightPin }, _react2.default.createElement(_OMPropertyListCell2.default, { locale: _this3.props.locale, isMobile: _this3.props.isMobile, isRtl: _this3.props.isRtl, translate: _this3.props.translate, id: id, photo: propertyImage, images: property.images, videoPoster: propertyVideoPoster, price: price, address: addressString, rooms: roomsData, parkingSpots: parking, city: address.city_name, cityEn: (0, _formatCityName2.default)((0, _get2.default)(property, 'address.en.city_name')), area: area, floor: floor, addressData: address, propertyType: _this3.props.translate('propertyTypes', property.property_type)(), propertyNote: propertyNote, isFavorite: isFavorite, isPromoted: property.is_promoted, hasVRLink: !!property.vr_link, optionType: optionType, isNewProperty: isNewProperty, isTopPromotedProperty: property.is_top_promoted, isRocketPromotedProperty: property.is_rocket_promoted, addPropertyNote: _this3.props.addPropertyNote, toggleFavorite: _this3.props.toggleFavorite, onHover: _this3.props.highlightPin, setPreloadData: _this3.props.setPreloadData, suppressLoading: _this3.props.suppressLoading, openDetailsPopup: _this3.props.openDetailsPopup, searchOption: property.search_option, showPromotion: showPromotion })));};this.renderNoResults = function (isProjects) {return isProjects ? _this3.renderProjectsNoResults() : _this3.renderPropertiesNoResults();};};exports.default = PropertiesList;PropertiesList.propTypes = {
  updateRoute: _propTypes2.default.func,
  containerRef: _propTypes2.default.object,
  companyFindByNeighborhood: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  properties: _propTypes2.default.array, // eslint-disable-line react/no-unused-prop-types
  openDetailsPopup: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  translateCities: _propTypes2.default.func,
  translateProjects: _propTypes2.default.func,
  loadMore: _propTypes2.default.func,
  isLastPage: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  loaded: _propTypes2.default.bool,
  highlightPin: _propTypes2.default.func,
  disableHighlightPin: _propTypes2.default.func,
  publishClicked: _propTypes2.default.func.isRequired,
  favoriteProperties: _propTypes2.default.array,
  propertyNotes: _propTypes2.default.array,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  displayAllFavorites: _propTypes2.default.func,
  isFavoritesList: _propTypes2.default.bool,
  isMobileFiltersOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  propertiesQuantity: _propTypes2.default.number,
  projectsQuantity: _propTypes2.default.number,
  searchProperty: _propTypes2.default.func,
  skip: _propTypes2.default.number,
  suppressLoading: _propTypes2.default.func,
  setPreloadData: _propTypes2.default.func,
  saveSearchLocation: _propTypes2.default.func,
  isLargeSideBar: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertiesList/PropertiesList.js
// module id = 2825
// module chunks = 0